import {
    type MRT_RowData,
    type MRT_TableInstance,
    type MRT_TableOptions,
    useShadcnReactTable,
} from '@talentmesh/table';
import React, { useMemo } from 'react';
import { Progress } from '@/Components/shadcn';

const useShadcnTable = <T extends MRT_RowData>({
    data: dataProp,
    ...props
}: Omit<MRT_TableOptions<T>, 'data'> & {
    data?: MRT_TableOptions<T>['data'];
    isValidating?: boolean;
}): MRT_TableInstance<T> => {
    const data = useMemo(() => dataProp ?? [], [dataProp]);
    const table = useShadcnReactTable({
        autoResetPageIndex: true,
        enableBottomToolbar: false,
        enableColumnActions: false,
        enableColumnDragging: true,
        enableColumnOrdering: true,
        enableColumnPinning: true,
        enableColumnResizing: true,
        enableRowNumbers: false,
        enableRowSelection: true,
        enableStickyHeader: true,
        enableTopToolbar: true,
        sortDescFirst: true,
        manualFiltering: true,
        manualPagination: true,
        manualSorting: true,
        renderTopToolbar: () => (
            <div className="relative flex w-full">
                {props.isValidating && (
                    <div className="absolute inset-0 z-10 w-full">
                        <Progress data-cy="tableValidationProgress" className="h-1" indeterminate />
                    </div>
                )}
            </div>
        ),
        ...(props as any),
        mantineSelectAllCheckboxProps: {
            'data-cy': 'selectAllCheckbox',
            ...props.mantineSelectAllCheckboxProps,
        },
        mantineSelectCheckboxProps: {
            'data-cy': 'rowSelectCheckbox',
            ...props.mantineSelectCheckboxProps,
        },
        mantineTableContainerProps: { className: 'h-full', ...props.mantineTableContainerProps },
        data,
        state: { showLoadingOverlay: false, ...props.state },
    });

    return table as MRT_TableInstance<T>;
};

export default useShadcnTable;
